
import { Asset } from "./asset";
import { Gateway } from "./gateway";
import { Org } from "./org";
import { Site } from "./site";
export class DerivedAsset {
	id: number;
	title: string;
	value: number;
	orgShortTitle: string;
	siteTitle: string;
	gatewayTitle: string;
	org: Org;
	gateway: Gateway;
	site: Site;
	parent: Asset;
	children: Asset[];
	childrenCount: number;
	childrenAsString: string;

	constructor(data?: any) {
		this.org = new Org({ id: data.orgId, shortTitle: data.orgShortTitle });
		this.gateway = new Gateway({ id: data.gateway_id, title: data.gatewayTitle });
		this.site = new Site({ id: data.siteId, title: data.siteTitle });
		this.parent = new Asset(data);
		this.children = data.children.map((c: any) => new Asset(c));
		this.value = +data.value;
		this.id = data.id;
		this.title = data.title;
		this.childrenCount = this.children.length;
		this.childrenAsString = this.children.map(c => c.title).join(', ');
		this.siteTitle = this.site.title;
		this.orgShortTitle = this.org.shortTitle;
		this.gatewayTitle = this.gateway.title;
	}

	serialise() {
		return {
			id: this.parent.id,
			children: this.children.map(c => c.id)
		}
	}

	display() {
		return this.parent.title;
	}
}
